'use client';

import { useMemo, useCallback } from 'react';
import { useAuth } from 'src/context/auth';
import { useGetManagerReportsQuery } from 'src/api/redux';

const useDirectReports = () => {
  const { user } = useAuth();

  const { data: reports } = useGetManagerReportsQuery({
    companyId: user?.company?.id?.toString(),
    managerId: user?.id?.toString(),
  });

  const directReports = useMemo(() => {
    return reports?.results?.map((report) => report.id);
  }, [reports]);

  const checkReport = useCallback(
    (userId: number) => {
      return directReports?.includes(userId);
    },
    [directReports]
  );

  return {
    directReports,
    checkReport,
  };
};

export default useDirectReports;
